import { render, staticRenderFns } from "./NormalTemp.vue?vue&type=template&id=4b5c70fc&scoped=true"
import script from "./NormalTemp.vue?vue&type=script&lang=js"
export * from "./NormalTemp.vue?vue&type=script&lang=js"
import style0 from "./NormalTemp.vue?vue&type=style&index=0&id=4b5c70fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5c70fc",
  null
  
)

export default component.exports